import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FilterInputRow } from '@ami/react/core';
import MachineMakeAndModelFilter from '../machines/machineMakeAndModelFilter';
import { MachineMakeDropdown } from '../machines/MachineMakeDropdown';
import { MachineModelDropdown } from '../machines/MachineModelDropdown';

export default class MachineMakeAndModelFilterComponent extends Component {
  static propTypes = {
    filter: PropTypes.instanceOf(MachineMakeAndModelFilter).isRequired,
    updateFilter: PropTypes.func.isRequired,
  };

  updateFilter(filter) {
    this.props.updateFilter(filter);
  }

  onChangeMake = async (make) => {
    this.props.updateFilter({ make, machineId: null });
  };

  render() {
    const { filter } = this.props;
    return (
      <FilterInputRow label="Make & Model" labelClassName="col-form-label">
        <div className="row gy-1 gx-1">
          <div className="col-12 col-md-6 gy-1">
            <MachineMakeDropdown
              placeholder="All makes"
              isClearable={true}
              selectedId={filter.make}
              onChange={(make) => this.onChangeMake(make)}
              className="text-start"
            />
          </div>
          <div className="col-12 col-md-6 ">
            <MachineModelDropdown
              placeholder="All models"
              noOptions="Select a make first"
              isClearable={true}
              selectedId={filter.machineId}
              onChange={(machineId) => this.updateFilter({ machineId })}
              className="text-start"
              make={filter.make}
            />
          </div>
        </div>
      </FilterInputRow>
    );
  }
}
